export const EMAIL_SIGN_UP_MODAL = 'emailSignUpModal'

export const TITLE_SIGN_UP = 'SIGN UP'

export const TITLE_THANK_YOU = 'Thank you!'
